module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.isNew ? "brokerage-house single" : "brokerage-house"
  }, [_c('div', {
    staticClass: "column has-text-left box"
  }, [(!_vm.isNew) ? _c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteBrokerageHouse(_vm.houseObject.id)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Заголовок"
    }
  }, [_c('b-input', {
    model: {
      value: (_vm.houseObject.title),
      callback: function($$v) {
        _vm.$set(_vm.houseObject, "title", $$v)
      },
      expression: "houseObject.title"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Ссылка"
    }
  }, [_c('b-input', {
    model: {
      value: (_vm.houseObject.url),
      callback: function($$v) {
        _vm.$set(_vm.houseObject, "url", $$v)
      },
      expression: "houseObject.url"
    }
  })], 1), _vm._v(" "), _c('b-switch', {
    model: {
      value: (_vm.houseObject.isHidden),
      callback: function($$v) {
        _vm.$set(_vm.houseObject, "isHidden", $$v)
      },
      expression: "houseObject.isHidden"
    }
  }, [_vm._v("Cкрыть с сайта")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-field', {
    staticClass: "logo-wrapper mt-10",
    attrs: {
      "label": "Логотип"
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.imageUrl) ? _c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": function($event) {
        return _vm.$refs.loadLogoInput.click()
      }
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить\n      ")]) : _c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.removeImage
    }
  }, [_c('a', {
    staticClass: "button is-danger"
  }, [_vm._v("-")]), _vm._v("Удалить\n      ")]), _vm._v(" "), _c('input', {
    ref: "loadLogoInput",
    attrs: {
      "type": "file",
      "hidden": ""
    },
    on: {
      "change": _vm.loadLogo
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary mt-10 save-button",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("СОХРАНИТЬ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e4f1efd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BrandHistory/BrokerageHouseItem.vue
// module id = 895
// module chunks = 0